import {Injectable} from '@angular/core';
import {ConfirmDialogComponent} from "./confirm-dialog.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {Observable} from "rxjs/index";
import {ConnectDialog} from "./connect-dialog";

@Injectable({
    providedIn: 'root'
})
export class ConfirmDialogService {
    constructor(public dialog: MatDialog) {
    }

    confirmDialog(connectDialog : ConnectDialog): Observable<boolean> {
        if(!!connectDialog && !!connectDialog.message) {
            const configData = new MatDialogConfig();
            configData.maxWidth = "700px";
            configData.maxHeight = "700px";
            configData.data = connectDialog;
            const dialogRef = this.dialog.open(ConfirmDialogComponent, configData);
            return dialogRef.afterClosed();
        }
    }
}
